import { wrap } from 'svelte-spa-router'

// Components
import Home from './routes/home/Home.svelte';
import SameColor from './routes/same-color/SameColor.svelte';
import SameColorPlay from './routes/same-color/SameColorPlay.svelte';
import GoodColorName from './routes/good-color-name/GoodColorName.svelte';
import GoodColorNamePlay from './routes/good-color-name/GoodColorNamePlay.svelte';
import F1StartTimer from './routes/f1-start-timer/F1StartTimer.svelte';
import F1StartTimerPlay from './routes/f1-start-timer/F1StartTimerPlay.svelte';
import LightsWall from './routes/lights-wall/LightsWall.svelte';
import LightsWallPlay from './routes/lights-wall/LightsWallPlay.svelte';
import Ranking from './routes/ranking/Ranking.svelte';
import NotFound from './routes/NotFound.svelte';

const routes = {
    // Exact path
    '/': Home, // Choix du jeu
    '/same-color/': SameColor, // Choix de la difficulté
    '/same-color/:difficulty': SameColorPlay, // Jeu
    '/good-color-name/': GoodColorName, // Choix de la difficulté
    '/good-color-name/:difficulty': GoodColorNamePlay, // Jeu
    '/f1-start-timer/': F1StartTimer, // Choix de la difficulté
    '/f1-start-timer/:difficulty': F1StartTimerPlay, // Jeu
    '/lights-wall/': LightsWall, // Choix de la difficulté
    '/lights-wall/:difficulty': LightsWallPlay, // Jeu
    '/ranking/:gameName/:difficulty/': Ranking, // Classement sans résultat à enregistrer
    '/ranking/:gameName/:difficulty/:result': Ranking, // Classement avec résultat à enregistrer
    '*': NotFound, // Erreur 404
}

export default routes
